import {useMutation} from "@apollo/client";
import {
  AddArticleEventDocument,
  AddArticleEventInput
} from "generated/graphql";

export const useAddArticleEvent = () => {
  const [mutate] = useMutation(AddArticleEventDocument, {
    update(cache, { data }) {
      const ev = data?.addArticleEvent.event;
      if (!ev) return;
      cache.modify({
        id: `Article:${ev.articleId}`,
        fields: {
          events: (existing: readonly any[]) => [ev, ...existing]
        }
      })
    }
  });

  return (input: AddArticleEventInput) => mutate({ variables: { input }});
}